// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"831":"5fa75af0","959":"519ffce7"}[chunkId] + ".chunk.js";
};